import { useMountEffect } from "@react-hookz/web";
import { format } from "date-fns";
import type { FunctionComponent } from "react";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import { useRosettaGA4TrackingParameters } from "scmp-app/lib/rosetta/hooks/rosetta-ga4-tracking-parameters";

import { Container, Icon, Message, Title } from "./styles";

type Props = {
  className?: string;
  expiryDate?: Date | null;
  isWithinHalf: boolean;
  url: string;
};
export const UpdatePaymentMessage: FunctionComponent<Props> = ({
  className,
  expiryDate,
  isWithinHalf,
  url,
}) => {
  const rosettaGA4BaseParameters = useRosettaGA4TrackingParameters();

  useMountEffect(() => {
    sendGA4Tracking({
      action: "imp",
      category: "myaccount",
      customized_parameters: {
        ...rosettaGA4BaseParameters,
        call_to_action: "update payment",
        trigger_point: "my account update payment overlay",
      },
      subcategory: "subscription",
    });
  });

  return (
    <Container
      className={className}
      href={url}
      onClick={event => {
        event.preventDefault();
        sendGA4Tracking({
          action: "click",
          category: "myaccount",
          customized_parameters: {
            ...rosettaGA4BaseParameters,
            call_to_action: "update payment",
            trigger_point: "my account update payment overlay",
          },
          subcategory: "subscription",
        });
        window.open(url);
      }}
    >
      <Icon />
      <Title>Your subscription failed to renew.</Title>
      <Message>
        Please <u>add a new payment card</u> to
        {isWithinHalf || !expiryDate
          ? " reactivate access."
          : ` avoid losing access on ${format(expiryDate, "dd MMM yyyy")}.`}
      </Message>
    </Container>
  );
};

UpdatePaymentMessage.displayName = "UpdatePaymentMessage";
